module.exports = __webpack_public_path__ + "f21748f8d0478b7be45c9c40e0410177.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/david cabrera.png
// module id = 596
// module chunks = 0